import React, { useState } from "react"

import InlineButtons from "../InlineButtons/"

import "./CountryCardFactors.scss"
import DataLoader, { years } from "../DataLoader"
import gradient from "../utils/gradient"
import CountryFactorFillGraph from "../CountryFactorFillGraph/"
import isEqual from "lodash/isEqual"
import SingleFillGraph from "../SingleFillGraph"
//import { factorImages } from "../images/factor_icons/factorImages"
import classnames from "classnames"

import arrowDown from "../images/arrow-down.svg"
import arrowUp from "../images/arrow-up.svg"
import { animated, useSprings } from "react-spring"

export default function CountryCardFactors(props) {
  const [previousFactors, setPreviousFactors] = useState(false)
  const [factorSort, setFactorSort] = useState("alphabetical")
  const [factorsExpanded, setFactorsExpanded] = useState([])

  const {
    selectedCountry,
    selectedYear,
    countryData,
    factorSelected,
    selectedFactor,
    factorIndex,
  } = props

  const yearIndex = years.indexOf(selectedYear)

  const factors = factorSelected
    ? DataLoader.dataByYear[selectedYear].questionKeys.filter(
        (questionKey) => questionKey[0] === `${factorIndex + 1}`,
      )
    : DataLoader.dataByYear[selectedYear].aggregateFactorKeys

  if (!isEqual(factors, previousFactors)) {
    setPreviousFactors(factors)
    setFactorsExpanded(factorSelected ? [] : factors.map((d) => false))
  }

  const sortOptions = [
    { value: "value", label: `${factorSelected ? "Sub-" : ""}Factor Score` },
    {
      value: "alphabetical",
      label: `${factorSelected ? "Sub-" : ""}Factors 1-${factors.length}`,
    },
  ]

  // const collapseAll = () => {
  //   setFactorsExpanded(factorsExpanded.map(d => false))
  // }
  // const expandAll = () => {
  //   setFactorsExpanded(factorsExpanded.map(d => true))
  // }

  // const subfactorOptions = [
  //   { label: 'Collapse All', onClick: collapseAll, value: 'allCollapsed' },
  //   { label: 'Expand All', onClick: expandAll, value: 'allExpanded' },
  // ]

  const title = factorSelected ? (
    <span>
      <span className="fontCaps factorLabel">Factor {factorIndex + 1}</span> |{" "}
      {selectedFactor} Sub-factors for {selectedCountry}, {selectedYear}
    </span>
  ) : (
    `Behind the Numbers: Factor Scores for ${selectedCountry}, ${selectedYear}`
  )

  const factorsSorted = [...factors] // maybe actually do a sort here?
  if (factorSort === "value") {
    factorsSorted.sort((a, b) => {
      return countryData[b] - countryData[a]
    })
  }
  const [factorSprings, setFactorValues] = useSprings(
    factorsSorted.length,
    () => ({
      score: 0,
      regionalRank: 0,
      incomeRank: 0,
      globalRank: 0,
      regionalRankCount: 0,
      incomeRankCount: 0,
      globalRankCount: 0,
    }),
  )

  setFactorValues((factorIndex) => {
    const factor = factorsSorted[factorIndex]
    // Sub-factors with no score have null score and ranks; animate those to 0
    const score = countryData[factor] ?? 0
    const regionalRank = countryData[`${factor}_Rank_Region`] ?? 0
    const incomeRank = countryData[`${factor}_Rank_Income Group`] ?? 0
    const globalRank = countryData[`${factor}_Rank_Global`] ?? 0
    const regionalRankCount = countryData.Count_Region
    const incomeRankCount = countryData["Count_Income Group"]
    const globalRankCount = countryData.Count_Global

    return {
      score,
      regionalRank,
      incomeRank,
      globalRank,
      regionalRankCount,
      incomeRankCount,
      globalRankCount,
    }
  })

  const factorDivs = factorsSorted.map((factor, factorIndex) => {
    const {
      score,
      regionalRank,
      incomeRank,
      globalRank,
      regionalRankCount,
      incomeRankCount,
      globalRankCount,
    } = factorSprings[factorIndex]
    const factorParts = factor.split(" ")
    const factorName = factorParts.slice(factorSelected ? 1 : 2).join(" ")
    const cardFactorIndex = factors.indexOf(factor)
    const title = factorSelected
      ? `${factorParts[0]} | ${factorName}`
      : `Factor ${cardFactorIndex + 1} | ${factorName}`
    const factorNumber = factorSelected
      ? factorParts[0][0]
      : cardFactorIndex + 1
    const rawScore = countryData[factor]
    const hasScore = rawScore !== null
    const color = hasScore ? gradient(rawScore) : "#EBEBEB"

    let expandCollapseButton = null

    let scoreCOTIcon = null
    if (yearIndex !== 0) {
      const previousYear = years[yearIndex - 1]
      const previousYearData = DataLoader.dataByYear[
        previousYear
      ].countries.find((country) => country.Country === selectedCountry)
      const previousYearScore = previousYearData?.[factor]
      if (hasScore && previousYearScore != null) {
        if (previousYearScore > rawScore) {
          scoreCOTIcon = (
            <img
              src={arrowDown}
              className="updownArrow"
              width={12}
              height={13}
              alt=""
            />
          )
        } else if (previousYearScore < rawScore) {
          scoreCOTIcon = (
            <img
              src={arrowUp}
              className="updownArrow"
              width={12}
              height={13}
              alt=""
            />
          )
        }
      }
    }

    let gotoFactorPageCallback = () => {}
    if (!factorSelected) {
      // const expandCollapseFactor = (factorIndex) => {
      //   return () => {
      //     const newFactors = [...factorsExpanded]
      //     newFactors[cardFactorIndex] = !newFactors[cardFactorIndex]
      //     setFactorsExpanded(newFactors)
      //   }
      // }
      gotoFactorPageCallback = () => props.updateUrl("factor")(factorName)
      expandCollapseButton = (
        <div className="expandCollapseButton" onClick={gotoFactorPageCallback}>
          More Info
        </div>
      )
    }

    let subfactors = null
    if (!factorSelected && factorsExpanded[cardFactorIndex]) {
      const subfactorQuestions = DataLoader.dataByYear[
        selectedYear
      ].questionKeys.filter(
        (questionKey) => questionKey[0] === `${cardFactorIndex + 1}`,
      )

      subfactors = subfactorQuestions.map((subfactor, subfactorIndex) => {
        const score = countryData[subfactor]
        return (
          <div className="subfactor" key={subfactorIndex}>
            <div className="subfactorTitle">{subfactor}</div>
            <div className="subfactorFillGraph">
              <SingleFillGraph
                value={score}
                leftAxisLabel=""
                rightAxisLabel=""
              />
            </div>
          </div>
        )
      })
    }
    return (
      <div className="countryCardFactor" key={factorIndex}>
        <div className="cardFactorTitle">
          <span
            className={classnames("fontCaps label", {
              isLink: !factorSelected,
            })}
            onClick={gotoFactorPageCallback}
          >
            {title}
          </span>
          {expandCollapseButton}
        </div>
        <div className="factorContents">
          <div className="factorStats">
            <div style={{ backgroundColor: color }}>
              {hasScore ? (
                <animated.span>
                  {score.interpolate((n) => n.toFixed(2))}
                </animated.span>
              ) : (
                <span>N/A</span>
              )}
              {scoreCOTIcon}
            </div>
            <table>
              <tbody>
                <tr>
                  <td>Global Rank</td>
                  <td>
                    {hasScore ? (
                      <>
                        <animated.span>
                          {globalRank.interpolate(Math.round)}
                        </animated.span>
                        {" / "}
                        <animated.span>
                          {globalRankCount.interpolate(Math.round)}
                        </animated.span>
                      </>
                    ) : (
                      "N/A"
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Regional Rank</td>
                  <td>
                    {hasScore ? (
                      <>
                        <animated.span>
                          {regionalRank.interpolate(Math.round)}
                        </animated.span>
                        {" / "}
                        <animated.span>
                          {regionalRankCount.interpolate(Math.round)}
                        </animated.span>
                      </>
                    ) : (
                      "N/A"
                    )}
                  </td>
                </tr>
                <tr>
                  <td>Income Rank</td>
                  <td>
                    {hasScore ? (
                      <>
                        <animated.span>
                          {incomeRank.interpolate(Math.round)}
                        </animated.span>
                        {" / "}
                        <animated.span>
                          {incomeRankCount.interpolate(Math.round)}
                        </animated.span>
                      </>
                    ) : (
                      "N/A"
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="factorGraph">
            <CountryFactorFillGraph
              {...props}
              scoreKey={factor}
              printStyle="halfWidth"
            />
          </div>
        </div>
        {subfactors}
      </div>
    )
  })

  // const countNumFactorsExpanded = factorsExpanded.reduce((previous, current) => previous + (current ? 1 : 0) , 0)
  // const subFactorExpansionState = countNumFactorsExpanded === 0 ? 'allCollapsed' : (countNumFactorsExpanded === factorsExpanded.length ? 'allExpanded' : '')
  return (
    <div className="countryCard countryCardFactors">
      <div className="title fontTitle">
        <a
          name="sub-factors"
          className="cardAnchor"
          href="#sub-factors"
          aria-hidden="true"
          tabIndex={-1}
        />
        {title}
        <div className="factorsControls">
          <InlineButtons
            style={{ flexDirection: "row" }}
            value={factorSort}
            options={sortOptions}
            setValue={setFactorSort}
            instruction="Sort:"
          />
          {
            // factorSelected ? null :
            // <InlineButtons className='expandCollapseAll' style={{ flexDirection: 'row' }} value={subFactorExpansionState} options={subfactorOptions} instruction="Sub-factors:" />
          }
        </div>
      </div>

      {factorDivs}
    </div>
  )
}
